import { Component } from '@angular/core';
import { CardAdministrationService } from '../../services/card-administration.service';
import { environment } from '@environment/environment';

@Component({
    selector: 'app-process-confirmation-page',
    templateUrl: './process-confirmation-page.component.html',
    styleUrls: ['./process-confirmation-page.component.css'],
    standalone: false
})
export class ProcessConfirmationPageComponent {
  public titlepayment: string = '';
  public estatuspayment: string = 'GUARDADA';
  public tipo_compra: string = 'RECARGA';
  public aprobedpayment: boolean = true;
  public paidAmount: string = '';
  public reversedAmount: string = '';
  public numberauth: string = '0';
  public approvalCode: string = '0';
  public datepayment: string = '';
  public fechatrans: string = '';
  public horatrans: string = '';
  public isDam: boolean = false;
  public isDamtrans: boolean = true;
  public phoneNumber: string | null = '';
  public rejectReason: string = '';
  public isNationalCard: boolean = false;
  public isErrorDomiciliation: boolean = false;
  public MessageDomiciliation: String = '';
  private finalResponse: any;
  public currency: string = environment.currency;
  public channel: number = 0;

  constructor(
    private readonly _cardAdministrationService: CardAdministrationService
  ) {
    this.finalResponse = this._cardAdministrationService.finalServiceResponse;
    this.channel = Number(localStorage.getItem('channel'));
  }

  ngAfterViewInit() {
    if (this.finalResponse.resultCode === 'SUCCESS') {
      this.titlepayment = 'Tarjeta de credito/debito guardada con exito!';
      this.paidAmount = this.finalResponse.result.paid_amount;
      this.reversedAmount = this.finalResponse.result.reversed_amount;
      this.datepayment = this.finalResponse.result.date_time;
      this.estatuspayment = 'GUARDADA';
    } else {
      this.aprobedpayment = false;
      this.titlepayment = 'Lo sentimos tu tarjeta no pudo ser guardada';
      this.datepayment = this.finalResponse.result.date_time;
      this.paidAmount = this.finalResponse.result.paid_amount;
      this.reversedAmount = this.finalResponse.result.reversed_amount;
      this.rejectReason = this.finalResponse.resultMessage;
      this.estatuspayment = 'ERROR';
      this.currency = this.finalResponse.result.currency;
    }
  }
}
